module.exports = __webpack_public_path__ + "static/media/foam.4b6cd5fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/foam.jpg
// module id = 587
// module chunks = 0